module.exports = __webpack_public_path__ + "static/google-70b65b73aabaf818a69350eb3183046a.png";